/**
 * 契約者
 */
import Vue from 'vue'
import * as httpConst from '../../../constants/httpConst'
import * as types from '../../mutation-types/admin-types'
import {ADMIN_CONTRACTOR_RESET_CONDITION} from "../../mutation-types/admin-types";

const API_PATH = `${httpConst.ADMIN_ENDPOINT}/contractors`


const getDefaultState = () => {
  return {
    pagination: {
      current_page: 1,
      total_count: 0
    },
    condition: {
      name: null,
      contract_unit_type: null,
      mail_send_status: null,
    },
  }
}


const contractor = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 契約者一覧取得
     * @param dispatch
     * @param commit
     * @param state
     * @param name
     * @param page
     * @return {Promise<unknown>}
     */
    index ({ dispatch, commit, state }, { name, contract_unit_type, mail_send_status, page }) {
      dispatch('saveCondition', { name: name ,
                                   contract_unit_type: contract_unit_type,
                                   mail_send_status: mail_send_status
                                 })
      const params = { name: state.condition.name,
            contract_unit_type: state.condition.contract_unit_type,
            mail_send_status: state.condition.mail_send_status,
            page: page }
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          commit(types.ADMIN_CONTRACTOR, { content })
          resolve(data.content)
        })
      })
    },
    show ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    new () {
      const api_path = `${API_PATH}/new`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          resolve(data.content)
        })
      })
    },
    create ({ commit }, { params }) {
      return new Promise( ( resolve ) => {
        Vue.$http.post(API_PATH, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '登録しました' }, { root: true })
          resolve(content)
        } )
      })

    },
    edit ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}/edit`
      return new Promise((resolve) => {
        Vue.$http.get(api_path).then(data => {
          commit
          resolve(data.content)
        })
      })
    },
    update ({ commit },{ id, params }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.put(api_path, params).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '更新しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    destroy ({ commit }, { id }) {
      const api_path = `${API_PATH}/${id}`
      return new Promise( ( resolve ) => {
        Vue.$http.delete(api_path).then(data => {
          commit('snackbar/showInfo', { message: '削除しました' })
          resolve(data.content)
        })
      })
    },
    sendOpeningMail( { commit, state }, { id } ) {
      const api_path = `${API_PATH}/${id}/send_mail`
      return new Promise( ( resolve, _reject ) => {
        Vue.$http.put(api_path).then( data => {
          let content = data.content
          commit('snackbar/showInfo', { message: '送信しました' }, { root: true })
          resolve(content)
        } )
      })
    },
    saveCondition ({ commit, state }, { name, contract_unit_type, mail_send_status }) {
      const _name = (name !== undefined) ? name : state.condition.name
      const _contract_unit_type = (contract_unit_type !== undefined) ? contract_unit_type : state.condition.contract_unit_type
      const _mail_send_status = (mail_send_status !== undefined) ? mail_send_status : state.condition.mail_send_status
      const params = { name: _name,
                       contract_unit_type: _contract_unit_type,
                       mail_send_status: _mail_send_status
                      }
      commit(types.ADMIN_CONTRACTOR_CONDITION, { params })
    },
    resetState ({ commit }) {
      commit(types.ADMIN_CONTRACTOR_RESET_CONDITION)
    },
    resetPagination ({ commit }) {
      commit(types.ADMIN_CONTRACTOR_RESET_PAGINATION)
    },
  },
  mutations: {
    [types.ADMIN_CONTRACTOR_RESET_PAGINATION] (state) {
      Object.assign(state.pagination, getDefaultState().pagination)
    },
    [types.ADMIN_CONTRACTOR_RESET_CONDITION] (state) {
      Object.assign(state, getDefaultState())
    },
    [types.ADMIN_CONTRACTOR] (state, { content }) {
      state.pagination = content.pagination
    },
    [types.ADMIN_CONTRACTOR_CONDITION] (state, { params }) {
      state.condition.name = params.name
      state.condition.contract_unit_type = params.contract_unit_type
      state.condition.mail_send_status = params.mail_send_status
    }
  },
}

export default contractor
